import PropTypes from 'prop-types';
import React from 'react';
import { Button, Tabs } from '@opendate-app/setlist';

import './customWidgetBuilder/customWidgetBuilder.css';

const DESCRIPTIONS = {
  standard: 'Fans pick how many tickets they need and sort by Lowest price, Best seats, or By zone.',
  simple: 'One list in your ticket order, with no ticket-count filter or sort tabs. Seats sold in pairs show the price for the pair.'
};

const SeatedCheckoutVersionPicker = ({ simple, disabled, previewUrl, onChange }) => {
  const version = simple ? 'simple' : 'standard';

  return (
    <div className="cwb-widget-type-bar is-static seated-checkout-version">
      <span className="cwb-widget-type-label">Seat Map Checkout</span>
      <Tabs
        variant="button-border"
        size="sm"
        collapseBelow={0}
        aria-label="Seat map checkout version"
        items={[
          { value: 'standard', label: 'Standard', disabled },
          { value: 'simple', label: 'Simple', disabled }
        ]}
        value={version}
        onChange={(value) => {
          if (value !== version) onChange(value === 'simple');
        }}
      />
      <span className="seated-checkout-version-description">{DESCRIPTIONS[version]}</span>
      <span className="seated-checkout-version-previews">
        <Button as="a" variant="link-color" size="sm" href={`${previewUrl}?seat_map_checkout=standard`} target="_blank" rel="noopener noreferrer">
          Preview Standard
        </Button>
        <Button as="a" variant="link-color" size="sm" href={`${previewUrl}?seat_map_checkout=simple`} target="_blank" rel="noopener noreferrer">
          Preview Simple
        </Button>
      </span>
    </div>
  );
};

SeatedCheckoutVersionPicker.propTypes = {
  simple: PropTypes.bool,
  disabled: PropTypes.bool,
  previewUrl: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

SeatedCheckoutVersionPicker.defaultProps = {
  simple: false,
  disabled: false
};

export default SeatedCheckoutVersionPicker;
